import ModalGlobal from "../modalGlobalTopbar/ModalGlobalTopbar";
import style from "./ModalFrequencia.module.css";
import PessoaTurmaApi from "../../../services/PessoaTurmaApi";
import TurmaApi from "../../../services/TurmaApi";
import FrequenciaApi from "../../../services/FrequenciaApi";
import { useEffect, useState, useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import Alerta from "../../alerta/Alerta";

function ModalFrequencia({ mostrar, aoFechar, botaoRef }) {
  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });
  const [posicaoCalculada, setPosicaoCalculada] = useState(false);

  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      const left = Math.min(rect.right - 299, window.innerWidth - 310);
      const top = rect.bottom + 5;

      setPosicao({ top, left });
      setPosicaoCalculada(true);
    }
  };

  useEffect(() => {
    if (mostrar) {
      setPosicaoCalculada(false);

      setTimeout(() => {
        calcularPosicao();
      }, 0);

      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]);

  // --- Lógica de frequência abaixo permanece igual ---

  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [mensagemAlerta, setMensagemAlerta] = useState("");
  const [tipoAlerta, setTipoAlerta] = useState("");

  const [frequencia, setFrequencia] = useState("");
  const [turmas, setTurmas] = useState([]);
  const [pessoas, setPessoas] = useState([]);

  const [pessoaId, setPessoaId] = useState(0);
  const [turmaId, setTurmaId] = useState(0);
  const [dataPresenca] = useState(() => {
    const hoje = new Date();
    return hoje.toISOString().split("T")[0];
  });

  const [opcaoSelecionada, setOpcaoSelecionada] = useState("entrada");

  const ResetarFrequencias = () => {
    setTurmaId(0);
    setPessoaId(0);
    setFrequencia("");
  };

  const BuscarFrequenciasFiltro = async (pessoaId, turmaId) => {
    try {
      const listaFrequencias = await FrequenciaApi.listarInformacoesFrequenciasAsync(turmaId, dataPresenca);
      const frequenciaEncontrada = listaFrequencias.find(f => f.pessoaID == pessoaId && f.turmaID == turmaId);
      setFrequencia(frequenciaEncontrada ?? null);
    } catch (error) {
      console.error("Erro ao listar frequências", error.response?.data);
    }
  };

  const BuscarTurmasPorPessoa = async () => {
    try {
      const listaTurmas = await PessoaTurmaApi.listarTurmasPorPessoaAsync();
      setTurmas(listaTurmas);
    } catch {
      console.error("Nenhuma turma encontrada");
    }
  };

  const BuscarPessoasDaTurma = async () => {
    try {
      const listaPessoas = await TurmaApi.obterPessoasDaTurmaAsync(turmaId);
      setPessoas(listaPessoas.filter(f => f.tipoPessoa === 3));
    } catch {
      console.error("Nenhuma pessoa encontrada");
    }
  };

  const AtualizarFrequencia = async () => {
    try {
      await FrequenciaApi.atualizarFrequenciasAsync(turmaId, dataPresenca, frequencia.dataEntrada, frequencia.dataSaida, pessoaId);
      setMensagemAlerta(`Frequência salva com sucesso!`);
      setTipoAlerta("success");
      exibirAlerta(true);
      ResetarFrequencias();
    } catch (error) {
      setMensagemAlerta(`Erro ao salvar frequência: ${error.response?.data}`);
      setTipoAlerta("danger");
      exibirAlerta(true);
    }
  };

  const formatarHora = (datetime) => {
    const date = new Date(datetime);
    return date.toTimeString().slice(0, 5);
  };
  const MudarHoraParaData = (campo, horaDigitada) => {
    const [horas, minutos] = horaDigitada.split(':');
    const hoje = new Date();
    hoje.setHours(Number(horas));
    hoje.setMinutes(Number(minutos));
    hoje.setSeconds(0);
    hoje.setMilliseconds(0);


    const dataLocal = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}T${String(hoje.getHours()).padStart(2, '0')}:${String(hoje.getMinutes()).padStart(2, '0')}:00`;

    setFrequencia(prev => ({ ...prev, [campo]: dataLocal }));
  };

  const exibirAlerta = () => {
    setMostrarAlerta(true);
    setTimeout(() => setMostrarAlerta(false), 10000);
  };

  useEffect(() => {
    BuscarTurmasPorPessoa();
    BuscarPessoasDaTurma();
  }, [turmaId || pessoaId]);

  useEffect(() => {
    ResetarFrequencias();
  }, [mostrar]);

  return (
    <ModalGlobal mostrar={mostrar} aoFechar={aoFechar} botaoRef={botaoRef}>
      <Alerta
        tipo={tipoAlerta}
        mensagem={mensagemAlerta}
        visivel={mostrarAlerta}
        aoFechar={() => setMostrarAlerta(false)}
      />

      {posicaoCalculada && (
        <div
          ref={modalRef}
          className={style.container_modal}
          style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
        >
          <div className={style.header_frequencias}>
            <h5>Frequência</h5>
          </div>

          <div className={style.container_frequencias}>
            <div className={style.container_drop}>
              <Form.Select
                value={turmaId}
                onChange={(e) => {
                  const id = Number(e.target.value);
                  setTurmaId(id);
                  if (pessoaId && id) BuscarFrequenciasFiltro(pessoaId, id);
                }}
              >
                <option value="">Selecione uma turma</option>
                {turmas.map((turma) => (
                  <option key={turma.turmaId} value={turma.turmaId}>{turma.nome}</option>
                ))}
              </Form.Select>

              <Form.Select
                value={pessoaId}
                onChange={(e) => {
                  const id = Number(e.target.value);
                  setPessoaId(id);
                  if (turmaId && id) BuscarFrequenciasFiltro(id, turmaId);
                }}
                disabled={!turmaId}
              >
                <option value="">Selecione um aluno</option>
                {pessoas.map((pessoa) => (
                  <option key={pessoa.id} value={pessoa.id}>{pessoa.nomeCompleto}</option>
                ))}
              </Form.Select>
            </div>

            {frequencia && (
              <div className={style.toggle_container}>
                <div className={style.toggle_buttons}>
                  <button
                    className={`${style.botao_toggle} ${opcaoSelecionada === "entrada" ? style.ativo : ""}`}
                    onClick={() => setOpcaoSelecionada("entrada")}
                  >
                    Entrada
                  </button>
                  <button
                    className={`${style.botao_toggle} ${opcaoSelecionada === "saida" ? style.ativo : ""}`}
                    onClick={() => setOpcaoSelecionada("saida")}
                  >
                    Saída
                  </button>
                </div>

                <div className={style.conteudo_visivel}>
                  <div className={style.resultado}>
                    <input
                      type="time"
                      className={style.inputHora}
                      value={frequencia[opcaoSelecionada === "entrada" ? "dataEntrada" : "dataSaida"] ? formatarHora(frequencia[opcaoSelecionada === "entrada" ? "dataEntrada" : "dataSaida"]) : ""}
                      onChange={(e) => MudarHoraParaData(opcaoSelecionada === "entrada" ? "dataEntrada" : "dataSaida", e.target.value)}
                    />
                  </div>

                  <div className={style.botao_presenca}>
                    <Button onClick={AtualizarFrequencia} id={style.botao_salvar}>
                      <MdSave /> Salvar
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </ModalGlobal>
  );
}

export default ModalFrequencia;
